"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translationsNamespace = exports.defaultTranslations = void 0;
/* istanbul ignore file */

/**
 * DO NOT EDIT!
 * This file was autogenerated by npm script `localizations-codegen`.
 * Changes may cause incorrect behavior and will be lost when the file is regenerated.
 *
 * Run `npx localizations-codegen` to regenerate.
 */

const defaultTranslations = exports.defaultTranslations = {
  activate: 'activate',
  add: 'Add',
  added: 'Added',
  addedToYourOrderAtACost: 'Added to your order at a cost',
  addedToYourOrderWithout: 'Added to your order without cost',
  bpCount: '{0} BP',
  bvCount: '{0} BV',
  cancel: 'Cancel',
  cataloguePrice: 'Catalogue price',
  checkoutOffers: 'Checkout offers',
  clearBasket: 'clear basket',
  closeList: 'Close list',
  closeSetComponents: 'Close set components',
  combineYourOrder: 'Combine your order',
  continueShopping: 'continue shopping',
  customerOrders: 'Customer orders',
  cycle: 'Cycle',
  delete: 'Delete',
  doYouWantToClearYourBasket: 'Do you want to clear your basket?',
  earn: 'Earn',
  emptyBag: 'Empty bag',
  enjoyFreeShipping: 'Enjoy free shipping! Add your subscription to this order for a single, convenient delivery. Your future subscription deliveries will not be affected.',
  everyXweeks: 'Every {frequency} weeks',
  expiringInFewDays: '{0} expire in {1} days',
  favorites: 'favorites',
  favourite: 'Favourite',
  goToRewardsShop: 'Go to rewards shop',
  itemsAddedByOriflameWillBeKept: 'Items added by Oriflame will be kept.',
  lookingPrettyEmptyInYourBag: 'Looking pretty empty in your bag',
  manageSubscriptions: 'Manage subscriptions',
  more: 'More',
  myBag: 'my bag',
  newEdition: 'new edition',
  newEditionAvailable: 'new edition available',
  nextShipment: 'Next shipment',
  no: 'No',
  none: 'Undefined',
  notify: 'Notify',
  notifyMe: 'Notify me',
  openList: 'Open list',
  originalProduct: 'Original product',
  popular: 'Popular',
  postpone: 'Postpone',
  price: 'Price',
  promotionCode: 'Promotional code',
  qty: 'Qty',
  quantity: 'Quantity',
  recentlyViewed: 'Recently viewed',
  regularPrice: 'Regular price',
  related: 'Related',
  replace: 'Replace',
  replaced: 'Replaced!',
  reserve: 'Reserve',
  reserved: 'Reserved!',
  samples: 'Samples',
  shippingOffer: 'Shipping offer',
  showSetComponents: 'Show set components',
  step: 'Step',
  subscribe: 'Subscribe',
  subscribed: 'Subscribed!',
  subscriptions: 'Subscriptions',
  superdeal: 'Superdeal',
  total: 'Total',
  unitPrice: 'Unit price',
  unreserve: 'Unreserve',
  voucherCodeIsRequired: 'Voucher code is required',
  voucherCodeIsTooLong: 'Voucher code is too long',
  whatsInside: 'What`s inside',
  yes: 'Yes',
  youSave: 'You save',
  youStillHave0pointsLeft: 'You still have {0} points left'
};
const translationsNamespace = exports.translationsNamespace = 'checkout-basket';